<template>
  <div class='nowPlayingContainer'>
    <img class="inductee_img"
    :style="{visibility: inductee.ImageURL ? 'visible' : 'hidden'}"
    :src="overrideImage || 'http://classicalwalkoffame.org/inductees/' + inductee.ImageURL">
    <span class="nowplaying_text">{{ text }}</span><br>
    <span class="name">{{ inductee.InducteeName }}</span><br>
    <span class="song">{{ inductee.MusicTitle }}</span>
  </div>
</template>

<script>
export default {
  props: ['inductee', 'text', 'overrideImage']
}
</script>

<style lang="less">
.nowPlayingContainer {
  background: none;
  padding: 25px 10px 25px 10px;
  border-bottom: 1px solid #afd2ef;
  margin: 0px 0px 0px 0px;
  img.inductee_img {
    width: 60px;
    height: 60px;
    float: left;
    margin-right: 20px;
    margin-left: 20px;
  }
  .nowplaying_text {
    color: #9a4aaf;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: -5px;
    font-size: 15px;
  }
  .name {
    color: #fff;
    font-family: "myriad-pro", arial, sans-serif;
    font-weight: bold;
    font-size: 16px;
  }
  .song {
    color: #afd2ef;
    font-family: "myriad-pro", arial, sans-serif;
    font-weight: normal;
    font-style: italic;
    font-size: 15px;
  }
}

</style>